import React from 'react';
import { Input, Form, FormItemProps } from 'antd';
import { PasswordProps } from 'antd/es/input';
import styles from './Input.module.less';

interface InputPasswordProps {
  inputProps?: PasswordProps,
  itemProps?: FormItemProps
}

export const InputPassword = ({
  inputProps,
  itemProps,
}: InputPasswordProps) => {
  const { className: itemClassName = '', ...item } = itemProps || {};
  const { className = '', ...input } = inputProps || {};
  return (

    <Form.Item {...item} className={`${styles.formItem} ${itemClassName}`}>
      <Input.Password {...input} className={`${className}`} />
    </Form.Item>

  );
};
